import { ToolbarButton } from '@fluentui/react-components';
import { ArrowSyncRegular } from '@fluentui/react-icons';
import { DocToolbarLink } from '../documentation/DocToolbarLink';
import type { IQueryListProps } from '../list/QueryList';
import { triggerClearMessages } from '../message-bar-group/MessageBarGroup';
import { useJobsQueryRefresh } from './jobs-query';

const ButtonRefresh = () => {
    const refresh = useJobsQueryRefresh();
    return (
        <ToolbarButton
            aria-label="Liste mit Jobs aktualisieren"
            icon={<ArrowSyncRegular />}
            onClick={() => {
                triggerClearMessages();
                refresh();
            }}
            title="Liste aktualisieren"
        />
    );
};

export const toolbarItems: IQueryListProps['toolbar'] = {
    farItems: [<DocToolbarLink key="dl" />],
    items: [<ButtonRefresh key="br" />],
    overflowItems: [],
} as const;
